/**
 * @overview token业务处理
 */
import VueCookie from 'vue-cookie'
import Vue from 'vue';

let token = 'token';
const witch_token = localStorage.getItem('witch_token');

if (witch_token) {
  token = `token_${witch_token}`;
}

const get = () => localStorage.getItem(token);

const remove = () => localStorage.removeItem(token);

const set = tokens => {
  localStorage.setItem(token, tokens);
  VueCookie.set('im-token', tokens, { expires: 30, domain: Vue.prototype.$domain.domain });
};

const getCookie = (name) =>{
  var strcookie = document.cookie;//获取cookie字符串
  var arrcookie = strcookie.split("; ");//分割
  //遍历匹配
  for ( var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] === name){
      return arr[1];
    }
  }
  return "";
};

export default {
  remove,
  set,
  get,
  getCookie,
};



// WEBPACK FOOTER //
// ./src/utils/token.js